import Config from '../../config';
import Model from '../../model/model';
import RefBooksList from './refbooks.list';
import Form from '../../view/form';
import Server from '../../model/refbooks/server';
import Servers from '../../collection/refbooks/servers';

import { ask, } from '../../utils/popups';





const FilterModel = Model.extend( { defaults: {
    cluster: undefined,
} } )

export default RefBooksList.extend( { 

    template: 'module/refbooks/servers.list',

    url() {
        return 'scripts/servers/list';
    },

    open() {
        const form = new Form( {
            template: 'module/refbooks/servers.form',
            clusters: this.options.clusters,
        } );

        const makeDisableUpdateDedelePredicate = privilegeCode => 
            () =>
                !Config.privileges().includes( privilegeCode ) ||
                !['GLOBAL', 'CLUSTER'].includes( Config.level() ) ||

                // Роль уровня кластера может редактировать/удалять только сущности своего кластера;
                // в списке уже только "мои" сущности, но с примесью глобальных;
                // поэтому достаточно только запретить редактировать глобальные
                Config.level() === 'CLUSTER' && 
                    !this.options.paged.current().get( 'cluster' );

        const actions = this.options.actions = {
            
            defaults: 'edit',

            create: {

                disabled: () =>
                    !Config.privileges().includes( 'create_script' ) ||
                    !['GLOBAL', 'CLUSTER'].includes( Config.level() ),

                handler: () => {
                    const current = new Server();
                    const binding = form.bind( current );
                    binding.then( () => {
                        if (this.state().cluster && this.state().cluster.id != -1)
                            current.set( 'cluster', this.state().cluster );
                        else if (Config.level() === 'CLUSTER')
                            current.set( 'cluster', Config.cluster() );
                    } );

                    ask( binding,
                        'server::modal new - title', 'actions::create', 'actions::cancel', 
                        () => this.options.servers.save( form ) )
                            .then( () => this.options.source.reset(
                                this.options.servers.models,
                                { silent: true } // a sort of paranoia
                            ) )
                            .then( () => this.sort() )
                            .then( () => this.render() );
                },

            },

            edit: {

                disabled: makeDisableUpdateDedelePredicate( 'update_script' ),

                handler: current => 
                    ask( form.bind( current.clone() ),
                        'server::modal edit - title', 'actions::save', 'actions::close', 
                        () => this.options.source.save( form ) )
                            .then( () => this.sort() )
                            .then( () => this.render() ),

            },
            
            destroy: {

                disabled: makeDisableUpdateDedelePredicate( 'delete_script' ),

                handler: current =>
                    this.destroy( current, 
                        'server::modal delete - title', 
                        'server::modal delete - confirmation text' ),

            },
            
        };

        this.options.filter = new FilterModel( { 
            cluster: this.state().cluster,
        } )

        this.options.source = new Servers( this.options.servers.models );
        this.options.sorted = new Servers();
        this.options.filtered = new Servers();
        this.options.paged = new Servers( { actions, } );

        return this.sort().then( () => this.bind( this.options.filter ) );
    },

} );



// WEBPACK FOOTER //
// ./src/js/module/refbooks/servers.list.js